import React from 'react';
import { Accordion, Box } from '@ublend-npm/aulaui-core';
import SpaceList from './SpaceList';
import { Space } from './types';

type SpaceListAccordionProps = {
  label: string;
  spaces: Space[];
  onClick: () => void;
  onChange: () => void;
  expanded: boolean;
  onStar: () => Promise<void>;
};

const SpaceListAccordion = ({
  label,
  spaces,
  onClick,
  onChange,
  expanded,
  onStar,
}: SpaceListAccordionProps) => {
  return (
    <Box data-testid="space-list-accordion">
      <Accordion
        label={`${label} (${spaces.length})`}
        expanded={expanded}
        onChange={onChange}
        leftAligner
        size="large"
        sx={{
          mb: '0.5rem',
          bgcolor: 'transparent',
          '& .start-summary .MuiTypography-subtitle2': {
            fontSize: '20px',
            fontWeight: 600,
          },
        }}
      >
        <SpaceList spaces={spaces} onClick={onClick} onStar={onStar} />
      </Accordion>
    </Box>
  );
};

export default SpaceListAccordion;
